import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { CSSProperties } from "react";
import { categoryToIcon } from "../../lib/definitions";
import { categoryToColor } from "../../lib/lib";
import { ItemCategory } from "@ckal-software/ckal-lib/dist/apps/madplanen";

interface CategoryItemProps {
  category: ItemCategory;
  upDisabled: boolean;
  downDisabled: boolean;
  onChange(wasUp: boolean): void;
}

const iconStyles: CSSProperties = {
  fontSize: "24px",
};

export function CategoryItem(props: CategoryItemProps) {
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 30,
          height: 30,
          borderRadius: 8,
          background: `color-mix(in srgb, ${categoryToColor[props.category] || "#d1d5db"} 15%, transparent)`,
        }}
      >
        {categoryToIcon[props.category]}
      </div>
      <div
        style={{
          color: categoryToColor[props.category],
          fontSize: "16px",
          fontWeight: "bold",
          minWidth: 0,
          overflowWrap: "anywhere",
        }}
      >
        {props.category.toUpperCase()}
      </div>
      <UpOutlined
        style={{
          ...iconStyles,
          opacity: props.upDisabled ? 0.2 : undefined,
        }}
        onClick={() => {
          if (props.upDisabled) {
            return;
          }
          props.onChange(true);
        }}
      />
      <DownOutlined
        style={{ ...iconStyles, opacity: props.downDisabled ? 0.2 : undefined }}
        onClick={() => {
          if (props.downDisabled) {
            return;
          }
          props.onChange(false);
        }}
      />
    </>
  );
}
